import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, Button, Row, Col, Modal, HelpBlock } from 'react-bootstrap';

const btnInlineStyle =   {
    width: "100%",
    height: "45px",
    fontSize: "18px"
}
const fullWidth = {
    width: "100% ",
    textAlign: "center",
    fontSize: "18px"
}



export const NotifyErrorModal = ({ err, okButtonTitle, showModal, modalTitle, dispatch }) => (
  <div className="subscription-form-box notify-error">
    <Modal bsSize="small" show={showModal} onHide={() => dispatch({type:'HIDE_MODAL_2'})} dialogClassName="custom-modal" >
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={ 12 } sm={ 12 }>
            <FormGroup controlId="alert-modal-body">
              <div className="full-width-center-text" style={fullWidth}>
                {JSON.stringify(err)}
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <div className="full-width-center-text" style={fullWidth}>
            <Button className="btn-main-green" style={btnInlineStyle} type="submit" onClick={() => {
              window.location.reload()
              dispatch({type:'HIDE_MODAL_2'})
            }}>
              {okButtonTitle}
            </Button>
          </div>
        </Row>

      </Modal.Body>
    </Modal>

  </div>
)

export default connect(
  // ownProps in this case are modalProps passed from the action or reducer
  (state, ownProps) => ({
    modalTitle: "We've encountered an error",
    okButtonTitle: "Try reload",
    showModal: true,
    // err: "We've encountered an error",

    // ...state.enterprise
    // ...ownProps
    err: ownProps//? ownProps.err : 'foo'
  })
)(NotifyErrorModal)



// WEBPACK FOOTER //
// ./src/modal/NotifyErrorModal.js